// src/components/layout/BottomNav.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../styles/bottom-nav.css';

const BottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <div className="bottom-nav">
      <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
        <i className="nav-icon">🏠</i>
        <span className="nav-label">Home</span>
      </Link>
      
      <Link to="/explore" className={`nav-item ${isActive('/explore') ? 'active' : ''}`}>
        <i className="nav-icon">🔍</i>
        <span className="nav-label">Explore</span>
      </Link>
      
      <Link to="/notifications" className={`nav-item ${isActive('/notifications') ? 'active' : ''}`}>
        <i className="nav-icon">🔔</i>
        <span className="nav-label">Notifications</span>
      </Link>
      
      <Link to={`/profile/${user?.username}`} className={`nav-item ${isActive(`/profile/${user?.username}`) ? 'active' : ''}`}>
        <i className="nav-icon">👤</i>
        <span className="nav-label">Profile</span>
      </Link>
    </div>
  );
};

export default BottomNav;